import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { COMPACT_THRESHOLDS } from "./constants";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Indian Rupee formatter
export const fmtINR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(n);
};

// Number formatter (no currency symbol)
export const fmtNum = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '0';
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0,
  }).format(n);
};

// Compact number formatter (for chart axes)
export const fmtCompact = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '0';
  if (n >= COMPACT_THRESHOLDS.CRORE) return `${(n / COMPACT_THRESHOLDS.CRORE).toFixed(1)}Cr`;
  if (n >= COMPACT_THRESHOLDS.LAKH) return `${(n / COMPACT_THRESHOLDS.LAKH).toFixed(1)}L`;
  if (n >= COMPACT_THRESHOLDS.THOUSAND) return `${(n / COMPACT_THRESHOLDS.THOUSAND).toFixed(1)}K`;
  return n.toString();
};

// Parse formatted number
export const parseFormattedNumber = (str) => {
  if (!str) return 0;
  const cleaned = String(str).replace(/[^0-9.]/g, '');
  return Number(cleaned) || 0;
};
